import React, { useEffect, useState } from "react";

import PageView from "./PageView";
import MessageView from "./MessageView";
import LoginView from "./Login/LoginView";
import LoginLostPassword from "./Login/LoginLostPassword";
import UserAreaView from "./UserArea/UserAreaView";
import ActivationPage from "./Activation/ActivationPage";
import AdminPersons from "./Person/AdminPersons";
import AdminPerson from "./Person/AdminPerson";
import AdminPages from "./Page/AdminPages";
import AdminPage from "./Page/AdminPage";
import AdminProducts from "./Product/AdminProducts";
import AdminProduct from "./Product/AdminProduct";
import AdminOrders from "./Activation/AdminOrders";
import SupportPage from "./SupportPage";
import ResendSerial from "./ResendSerial";
import TransferLicense from "./UserArea/TransferLicenseView";
import FastSpringUrlCheckout from "./FastSpring/FastSpringUrlCheckout";

import { Route, NavLink, Routes } from "react-router-dom";
import ShopCartButton from "./Shop/ShopCartButton";
import useSizeWidth from "../SizeListener";

import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Config } from "../config";
import { AuthenticationService } from "../Authentication";

import "../custom.scss";

const isClient = typeof window !== "undefined";

const Navigation = ({ initialData }) => {

  // const [menuItems, setMenuItems] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  // null on the server and on the first client render, so hydration matches the SSR html
  // (the server can't read the login from localStorage). Set after mount by the subscription below.
  const [currentUser, setCurrentUser] = useState(null);

  useSizeWidth(); // keep your size listener (no SSR issue)

  // Fetch menu items only on the client
  useEffect(() => {
    if (!isClient) return;

    const fetchMenuItems = async () => {
      try {
        const response = await fetch(Config.apiUrl + "/page/menuitems");
        const data = await response.json();
        setMenuItems(data);
      } catch (err) {
        console.error("Failed to fetch menu items", err);
      }
    };

    fetchMenuItems();

    // Subscribe to user changes only in the browser
    const subscription = AuthenticationService.currentUser.subscribe((user) => {
      setCurrentUser(user);
      fetchMenuItems();
    });

    return () => subscription.unsubscribe();
  }, []); // dont add menuItems as dependency to trigger refresh when something changes // logout and login for example

  const renderShopCartButton = (mobile) => {
    return <ShopCartButton isMobile={mobile} />;
  };

  // ---- build nav links safely ----
  let navLinks = null;
  try {
    navLinks = menuItems.map((n) => (
      <Nav.Link eventKey={n.name} key={n.name} as={NavLink} to={n.url}>
        {n.name.toUpperCase()}
      </Nav.Link>
    ));
  } catch (err) {
    console.error("SSR: error rendering menu items:", err);
  }

  return (
    <>
      <Navbar 
        collapseOnSelect
        className="navbar navbar-dark overlay"
        expand="lg"
        sticky="top"
      >
        <div suppressHydrationWarning={true} className="container" style={{ minWidth: "360px" }}>
          {/* mobile / desktop layout is switched with CSS (lg breakpoint), not JS, so the
              server rendered html already fits the screen and nothing shifts after load (CLS) */}

          {/* mobile cart button */}
          <div className="d-lg-none" style={{ width: "auto", alignContent: "end" }}>
            {renderShopCartButton(true)}
          </div>

          <Navbar.Brand
            className="navbar-brand-padded"
            as={NavLink}
            to="/"
          >
            <img
              className="no_shadow"
              src="/logo.svg"
              alt="TAL"
              width="160px"
              height="53px"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="container-fluid">
              {navLinks}

              <Nav.Link
                className="nav-link-support"
                eventKey="2"
                key="Support"
                as={NavLink}
                to="/support"
              >
                SUPPORT
              </Nav.Link>

              {currentUser ? (
                <Nav.Link
                  eventKey="3"
                  key="UserArea"
                  as={NavLink}
                  to="/userarea"
                >
                  MY TAL
                </Nav.Link>
              ) : (
                <Nav.Link
                  eventKey="4"
                  key="Login"
                  as={NavLink}
                  to="/login"
                >
                  LOGIN
                </Nav.Link>
              )}

              {currentUser &&
              currentUser?.name === "admin" ? (
                <NavDropdown key="admin" title="ADMIN" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/admin/persons">
                    PERSONS
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/admin/pages">
                    PAGES
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/admin/products">
                    PRODUCTS
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/admin/orders">
                    ACTIVATION CODES
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/activate">
                    ACTIVATION PAGE
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <div></div>
              )}

              {currentUser && (
                <Nav.Link
                  key="Logout"
                  as={NavLink}
                  to="/"
                  onClick={() => AuthenticationService.logout()}
                >
                  LOGOUT
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>

          {/* desktop cart button */}
          <div className="d-none d-lg-block">
            {renderShopCartButton(false)}
          </div>
        </div>
      </Navbar>

      {/* ROUTES */}
      <Routes>
        <Route path="/admin/resendserial/:productName" element={<ResendSerial />}/>
        <Route path="/transferlicense/:id" element={<TransferLicense />} />
        <Route path="/directurlcheckout/:productName?/:couponCode" element={<FastSpringUrlCheckout />}/>
        <Route path="/login/lostpassword" element={<LoginLostPassword />} />
        <Route path="/login/" element={<LoginView />} />
        <Route path="/contactsupport" element={<SupportPage />} />
        <Route path="/messageview" element={<MessageView />} />
        <Route path="/userarea" element={<UserAreaView />} />
        <Route path="/activate" element={<ActivationPage />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/admin/persons" element={<AdminPersons />} />
        <Route path="/admin/products" element={<AdminProducts />} />
        <Route path="/admin/product/:id" element={<AdminProduct />} />
        <Route path="/admin/person/:id" element={<AdminPerson />} />
        <Route path="/admin/page/:id" element={<AdminPage />} />
        <Route path="/admin/pages" element={<AdminPages />} />
        <Route path="/:pathParam1?/:pathParam2?/:pathParam3?" element={<PageView initialData={initialData}/>} />
      </Routes>
    </>
  );
};

export default Navigation;
